
import { useMemo, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { sanitizeDecimal } from "@/utils";
import { useQuizContext } from "@/pages/quiz/context";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { HeightWeightAnswer } from "@/pages/quiz/15000/questions/HeightWeightInputsWithBMI";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Input } from "@/pages/quiz/15000/components/Input";
import { validateWeight } from "@/utils/validateField/weight";

const CustomNumberInputQuestion = ({
  question,
  questionValue,
  setQuestionAnswer,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const { answers } = useQuizContext();
  const [errorMessage, setErrorMessage] = useState("");

  const {
    name,
    attributes: {
      placeholder,
    }
  } = question;

  const questionNamesWithLowerWeight = ['app-weight-goal', 'core-weight-goal'];
  const isLowerWeightQuestion = questionNamesWithLowerWeight.includes(name);

  const heightWeightWithBmiQuestion = useMemo(() => Object.values(answers).find(
    (answer) => answer.blockName === "height-weight-input-fields-with-bmi"
  )?.value as HeightWeightAnswer, [answers]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuestionValue(sanitizeDecimal(e.target.value));
    setErrorMessage("");
  };

  const onSubmitAnswer = () => {
    const error = validateWeight({
      currentWeight: +heightWeightWithBmiQuestion?.weight,
      value: +questionValue,
      isLowerWeightQuestion,
    });

    if (error) {
      setErrorMessage(error);
      return;
    }

    setErrorMessage('');
    setQuestionAnswer(questionValue);
  };

  return (
    <div className="relative">
      <Input
        value={questionValue}
        placeholder={(placeholder as string) || ""}
        onChange={handleChange}
        inputMode="decimal"
        type="number"
      />
      <CSSTransition
        in={!!errorMessage}
        timeout={300}
        classNames="fade"
        unmountOnExit
      >
        <div
          className="mt-4 text-brick-red font-medium text-sm sm:text-base first-letter:capitalize"
        >
          {errorMessage}
        </div>
      </CSSTransition>
      <Button
        disabled={!questionValue?.trim()}
        onClick={onSubmitAnswer}
      />
    </div>
  );
};

export { CustomNumberInputQuestion };
